/**
 * @generated SignedSource<<f04135678f2479ef9979f390cd905341>>
 * @relayHash 1507bec46d7f308333eb71896f01277c
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 1507bec46d7f308333eb71896f01277c

import { ConcreteRequest } from 'relay-runtime';
export type AssociationType = "MANDATORY" | "OPTIONAL";
export type HealthInformationStatus = "NONE" | "SOME" | "UNKNOWN";
export type Ch_updateAllPatientConditionsInput = {
  conditionStatus?: HealthInformationStatus | null;
  conditions: ReadonlyArray<ConditionInput>;
  patientId: string;
};
export type ConditionInput = {
  comment?: string | null;
  diagnosisCode: string;
};
export type chUpdateAllPatientConditionsMutation$variables = {
  input: Ch_updateAllPatientConditionsInput;
};
export type chUpdateAllPatientConditionsMutation$data = {
  readonly updateAllPatientConditions: {
    readonly errors: ReadonlyArray<{
      readonly message?: string;
      readonly patientId?: string;
    }> | null;
    readonly patientConditionInformationOutput: {
      readonly conditions: ReadonlyArray<{
        readonly comment: string | null;
        readonly icdDiagnosis: {
          readonly associationType: AssociationType | null;
          readonly diagnosisCode: string;
          readonly id: string;
          readonly isAssociation: boolean;
          readonly primaryCode: string | null;
          readonly secondaryCode: string | null;
          readonly text: string;
        };
      }>;
      readonly id: string;
      readonly status: HealthInformationStatus;
    } | null;
  };
};
export type chUpdateAllPatientConditionsMutation = {
  response: chUpdateAllPatientConditionsMutation$data;
  variables: chUpdateAllPatientConditionsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v3 = [
  (v2/*:: as any*/)
],
v4 = {
  "kind": "InlineFragment",
  "selections": (v3/*:: as any*/),
  "type": "Error",
  "abstractKey": "__isError"
},
v5 = {
  "kind": "InlineFragment",
  "selections": (v3/*:: as any*/),
  "type": "IcdCodeNotUnique",
  "abstractKey": null
},
v6 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "patientId",
      "storageKey": null
    },
    (v2/*:: as any*/)
  ],
  "type": "PatientNotFound",
  "abstractKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "PatientConditionInformationOutput",
  "kind": "LinkedField",
  "name": "patientConditionInformationOutput",
  "plural": false,
  "selections": [
    (v7/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ConditionOutput",
      "kind": "LinkedField",
      "name": "conditions",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "comment",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "IcdDiagnosis",
          "kind": "LinkedField",
          "name": "icdDiagnosis",
          "plural": false,
          "selections": [
            (v7/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isAssociation",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "diagnosisCode",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "primaryCode",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "secondaryCode",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "associationType",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "text",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "chUpdateAllPatientConditionsMutation",
    "selections": [
      {
        "alias": "updateAllPatientConditions",
        "args": (v1/*:: as any*/),
        "concreteType": "Ch_updateAllPatientConditionsPayload",
        "kind": "LinkedField",
        "name": "ch_updateAllPatientConditions",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*:: as any*/),
              (v5/*:: as any*/),
              (v6/*:: as any*/)
            ],
            "storageKey": null
          },
          (v8/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "chUpdateAllPatientConditionsMutation",
    "selections": [
      {
        "alias": "updateAllPatientConditions",
        "args": (v1/*:: as any*/),
        "concreteType": "Ch_updateAllPatientConditionsPayload",
        "kind": "LinkedField",
        "name": "ch_updateAllPatientConditions",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v4/*:: as any*/),
              (v5/*:: as any*/),
              (v6/*:: as any*/)
            ],
            "storageKey": null
          },
          (v8/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "1507bec46d7f308333eb71896f01277c",
    "metadata": {},
    "name": "chUpdateAllPatientConditionsMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "be8b6d6ce92d7fa6564c9efd8c8834d2";

export default node;
